import t from "@/lang/lang";
import { useParams } from "react-router";
import { SamplesForDeliveryCard } from "@/services/backend/samples/components/samples-for-delivery";
import {
  useHtzWorkOrderListPositionQuery,
  useHtzWorkOrderShowQuery,
  workOrderPositionsRequest,
} from "@/services/backend/htz/work-order/api/work-order-api";
import { AlertTriangle } from "lucide-react";
import { HTZ_WORK_ORDER_NAMESPACE } from "@/services/backend/htz/work-order/types/work-order";
import { FilterMode } from "@/shared/lib/filter/filter";
import { DeliveriesCard } from "@/services/backend/samples/components/deliveries-table";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

export function LaboratoryRoute() {
  const { workOrderId } = useParams();
  const { data: positionList } = useHtzWorkOrderListPositionQuery(
    workOrderPositionsRequest(workOrderId!),
  );
  const positions = positionList?.items;
  const { data: workOrder } = useHtzWorkOrderShowQuery({ id: workOrderId! });

  // The samples are listed for the company of the work order, which the
  // initial request needs up front.
  if (!workOrder) {
    return null;
  }

  // Samples and deliveries are entities of their own. Their validation
  // errors must not land in the scope of the work order.
  return (
    <ErrValidationFailedContextProvider>
      <div className="grid gap-2">
        <SamplesForDeliveryCard
          documentId={workOrderId!}
          documentNamespace={HTZ_WORK_ORDER_NAMESPACE}
          initialRequest={{
            company: { active: true, values: [workOrder.companyId] },
            document: { active: true, values: [workOrderId!] },
            delivery: { active: true, mode: FilterMode.IsNull },
          }}
          // Show the position(s) where the sample was used.
          relatedEntity={(sample) => {
            if (!positions) return;

            const samplePositions = positions.filter((p) =>
              p.microbialAssessments.some((ma) => ma.sampleId === sample.id),
            );

            if (samplePositions.length === 0) {
              return (
                <span className="text-destructive flex gap-2">
                  <AlertTriangle className="size-5" />
                  {t("Probe ist mit keiner Position verknüpft")}
                </span>
              );
            }

            return samplePositions.map((pos) => pos.number).join(", ");
          }}
          getAssignment={(sample) => {
            if (!positions) return undefined;
            const samplePositions = positions.filter((p) =>
              p.microbialAssessments.some((ma) => ma.sampleId === sample.id),
            );
            return {
              positionNumbers: samplePositions.map((p) => p.number),
            };
          }}
        />
        <DeliveriesCard
          initialRequest={{
            document: { active: true, values: [workOrderId!] },
          }}
        />
      </div>
    </ErrValidationFailedContextProvider>
  );
}
